export interface BasicColors {
  black: string;
  white: string;
}

export const basicColors: BasicColors = {
  black: '#202427',
  white: '#ffffff',
};
